import React, { createContext, useState, useContext, ReactNode } from "react";

// Define the shape of the context
interface ModalContextType {
	isModalOpen: boolean;
	setModalState: (state: boolean) => void;
}

// Create the context
const ModalContext = createContext<ModalContextType | undefined>(undefined);

// Provider component
export const ModalProvider: React.FC<{ children: ReactNode }> = ({
	children,
}) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const setModalState = (state: boolean) => setIsModalOpen(state);

	return (
		<ModalContext.Provider value={{ isModalOpen, setModalState }}>
			{children}
		</ModalContext.Provider>
	);
};

// Custom hook for easier consumption
export const useModal = (): ModalContextType => {
	const context = useContext(ModalContext);
	if (!context) {
		throw new Error("useModal must be used within a ModalProvider");
	}
	return context;
};
